import { render, staticRenderFns } from "./buy-list.vue?vue&type=template&id=3d6c3752"
import script from "./buy-list.vue?vue&type=script&lang=js"
export * from "./buy-list.vue?vue&type=script&lang=js"
import style0 from "./buy-list.vue?vue&type=style&index=0&id=3d6c3752&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports